import { createElement, Fragment } from 'react';
import { oneOfType, func, node, string, bool, oneOf } from 'prop-types';
import { animatePropTypes, restrictHidePropTypes, animateDefaultProps, restrictDefaultProps } from './types/props.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import Portal from './Portal/index.js';
import Backdrop from './Backdrop/index.js';
import { a as isFunction } from './chunk-5c9bbccf.js';
import { a as TrapFocus } from './chunk-abb87050.js';
import ModalContainer from './Modal/ModalContainer.js';
import _Modal from './Modal/styled.js';
import ModalHide from './Modal/ModalHide.js';
import ModalShow from './Modal/ModalShow.js';

var Modal = function Modal(_ref) {
  var children = _ref.children,
      delay = _ref.delay,
      duration = _ref.duration,
      fade = _ref.fade,
      hide = _ref.hide,
      hideOnEsc = _ref.hideOnEsc,
      hideOnClickOutside = _ref.hideOnClickOutside,
      isVisible = _ref.isVisible,
      kind = _ref.kind,
      _ref$renderWrapper = _ref.renderWrapper,
      renderWrapper = _ref$renderWrapper === void 0 ? function (children) {
    return children;
  } : _ref$renderWrapper,
      showActionButtons = _ref.showActionButtons,
      showCloseButton = _ref.showCloseButton,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "delay", "duration", "fade", "hide", "hideOnEsc", "hideOnClickOutside", "isVisible", "kind", "renderWrapper", "showActionButtons", "showCloseButton"]);

  return createElement(Portal, null, createElement(TrapFocus, {
    isActive: isVisible,
    usesPortal: true
  }, function (_ref2) {
    var fallbackFocusRef = _ref2.fallbackFocusRef,
        initialFocusRef = _ref2.initialFocusRef;
    return createElement(Fragment, null, createElement(Backdrop, {
      delay: delay,
      duration: duration,
      expand: undefined,
      hide: hideOnClickOutside && kind !== 'alert' ? hide : undefined,
      fade: fade,
      hideOnEsc: kind === 'alert' ? false : hideOnEsc,
      isVisible: isVisible,
      slide: undefined,
      use: hideOnClickOutside && kind !== 'alert' ? ModalHide : undefined
    }), createElement(_Modal, _extends({
      "aria-modal": "true",
      delay: delay,
      duration: duration,
      fade: fade,
      hideOnEsc: kind === 'alert' ? false : hideOnEsc,
      hideOnClickOutside: kind === 'alert' ? false : hideOnClickOutside,
      isVisible: isVisible
    }, props), renderWrapper(isFunction(children) ? children({
      fallbackFocusRef: fallbackFocusRef,
      initialFocusRef: initialFocusRef
    }) : children)));
  }));
};
var modalPropTypes = _objectSpread({}, animatePropTypes, restrictHidePropTypes, {
  children: oneOfType([func, node]).isRequired,
  className: string,
  isVisible: bool,
  hide: func,
  kind: oneOf(['alert']),
  showActionButtons: bool,
  showCloseButton: bool,
  renderWrapper: func
});
Modal.propTypes = modalPropTypes;
var modalDefaultProps = _objectSpread({}, animateDefaultProps, restrictDefaultProps, {
  className: undefined,
  isVisible: false,
  kind: undefined,
  showActionButtons: false,
  showCloseButton: false,
  hideOnClickOutside: true,
  hideOnEsc: true,
  renderWrapper: function renderWrapper(children) {
    return children;
  }
});
Modal.defaultProps = modalDefaultProps;
Modal.Container = ModalContainer;
Modal.Hide = ModalHide;
Modal.Show = ModalShow;
var C = Modal;

export { modalPropTypes as a, modalDefaultProps as b, C as c };
